import React from 'react';
import StaffForm from '../../Components/Staff/StaffForm';

export default function MainDoctorForm() {
  return (
    <StaffForm
      role="mainDoctor"
      title="Main Doctor"
      returnUrl="/main-doctor"
    />
  );
}

